/**
 * @generated SignedSource<<ec404f7c17bc2555103b240ac3359ccd>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type Pipeline_pipeline$fragmentType = any;
type ShowMoreFooter_connection$fragmentType = any;
type Welcome_organization$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Pipelines_organization$fragmentType: FragmentType;
export type Pipelines_organization$data = {|
  +allPipelines: ?{|
    +count: number,
  |},
  +id: string,
  +pipelines: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +description: ?string,
        +favorite: boolean,
        +id: string,
        +name: string,
        +$fragmentSpreads: Pipeline_pipeline$fragmentType,
      |},
    |}>,
    +$fragmentSpreads: ShowMoreFooter_connection$fragmentType,
  |},
  +slug: string,
  +$fragmentSpreads: Welcome_organization$fragmentType,
  +$fragmentType: Pipelines_organization$fragmentType,
|};
export type Pipelines_organization$key = {
  +$data?: Pipelines_organization$data,
  +$fragmentSpreads: Pipelines_organization$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "team",
  "variableName": "teamSearch"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "archivedFilter"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeGraphData"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pipelineFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tagsFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamSearch"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Pipelines_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Welcome_organization"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": "allPipelines",
      "args": [
        (v1/*: any*/)
      ],
      "concreteType": "PipelineConnection",
      "kind": "LinkedField",
      "name": "pipelines",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "archived",
          "variableName": "archivedFilter"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pageSize"
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": "NAME_WITH_FAVORITES_FIRST"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "pipelineFilter"
        },
        {
          "kind": "Variable",
          "name": "tags",
          "variableName": "tagsFilter"
        },
        (v1/*: any*/)
      ],
      "concreteType": "PipelineConnection",
      "kind": "LinkedField",
      "name": "pipelines",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowMoreFooter_connection"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PipelineEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Pipeline",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "favorite",
                  "storageKey": null
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "includeGraphData",
                      "variableName": "includeGraphData"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "Pipeline_pipeline"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "0733cb0336058c1e957c68bd2e10f9b8";

module.exports = ((node/*: any*/)/*: Fragment<
  Pipelines_organization$fragmentType,
  Pipelines_organization$data,
>*/);
